import * as yup from 'yup';

export const BANK_INFO_SCHEMA = yup.object({
  ibanNumber: yup
    .string()
    .required('شماره شبا اجباری است')
    .max(24, 'شماره شبا باید 24 رقم باشد')
    .min(24, 'شماره شبا باید 24 رقم باشد'),
  ownerName: yup.string().defined(),
  bankName: yup.string().defined()
});

export const BANK_NAMES: Record<string, string> = {
  MARKAZI: 'بانک مرکزی',
  SANAT_VA_MADAN: 'بانک صنعت و معدن',
  MELLAT: 'بانک ملت',
  REFAH: 'بانک رفاه',
  MASKAN: 'بانک مسکن',
  SEPAH: 'بانک سپه',
  KESHAVARZI: 'بانک کشاورزی',
  MELLI: 'بانک ملی',
  TEJARAT: 'بانک تجارت',
  SADERAT: 'بانک صادرات',
  TOSEAH_SADERAT: 'توسعه صادرات',
  POST: 'پست بانک',
  TOSEAH_TAAVON: 'توسعه تعاون',
  KHAVARMIANEH: 'خاورمیانه',
  NOOR: 'نور',
  IRAN_VENEZUELA: 'ایران ونزوئلا',
  PARSIAN: 'پارسیان',
  EGHTESAD_NOVIN: 'اقتصاد نوین',
  SAMAN: 'سامان',
  PASARGAD: 'پاسارگاد',
  SARMAYEH: 'سرمایه',
  SINA: 'سینا',
  MEHR_IRAN: 'مهر ایران',
  SHAHR: 'شهر',
  AYANDEH: 'آینده',
  GARDESHGARI: 'گردشگری',
  DAY: 'دی',
  IRANZAMIN: 'ایران زمین',
  RESALAT: 'رسالت',
  'بانک خاورمیانه': 'بانک خاورمیانه'
};
